import { GOI_PLATFORM_URL } from "goi_common";

export const parseToPrimeUrl = (url: string) => {
  const PRIME_URL = process.env.NEXT_PUBLIC_GOI_PRIME_URL || "";

  if (url.includes(PRIME_URL)) {
    return url.replace(PRIME_URL, "");
  } else {
    return GOI_PLATFORM_URL + url;
  }
};
